import { Observable } from 'rxjs';
import { Voce, CreateVoceDto, UpdateVoceDto, VociQueryParams } from '../../models/voci.model';
import { PaginatedResponse } from '../../models/preventivi.model';

export abstract class VociPort {
  abstract getList(params?: VociQueryParams): Observable<PaginatedResponse<Voce>>; 
  abstract getById(id: number): Observable<Voce>;
  abstract getByCapitoloId(idCapitolo: number): Observable<Voce[]>;
  abstract create(dto: CreateVoceDto): Observable<number>;
  abstract update(id: number, dto: UpdateVoceDto): Observable<number>;
  abstract delete(id: number): Observable<void>;
  abstract deleteSuggestion(id: number): Observable<void>;
}